export function getStorageValue(key) {
    const value = localStorage.getItem(key);
    try {
        return JSON.parse(value);
    } catch (err) {
        return value;
    }
}

export function setStorageValue(key, value) {
    const valueToSet = JSON.stringify(value);
    localStorage.setItem(key, valueToSet);
}
